
import React from "react";
import { useNavigate } from "react-router-dom";
import { FiX, FiTrash2, FiMinus, FiPlus } from "react-icons/fi";
import { useCart } from "../../context/CartContext";
import "./CartDrawer.css";

const CartDrawer = () => {
  const navigate = useNavigate();

  const {
    cartItems,
    cartTotal,
    isCartOpen,
    setIsCartOpen,
    removeFromCart,
    updateQuantity,
  } = useCart();

  if (!isCartOpen) return null;

  const handleCheckout = () => {
    const items = cartItems.map((item) => ({
      productId: item.productId,
      quantity: item.quantity,
      selectedChoiceIds: item.selectedChoiceIds || [],
    }));

    setIsCartOpen(false);

    navigate("/checkout", {
      state: { items },
    });
  };

  return (
    <div
      className="cart-overlay"
      onClick={() => setIsCartOpen(false)}
    >
      <div
        className="cart-drawer"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="cart-header">
          <div>
            <h2>My Shopping Cart</h2>
            <span>{cartItems.length} Products</span>
          </div>

          <button
            onClick={() => setIsCartOpen(false)}
            className="cart-close"
          >
            <FiX />
          </button>
        </div>

        {cartItems.length === 0 ? (
          <div className="empty-cart">
            <h3>Your Cart is Empty!</h3>
            <p>Explore our premium spiritual products.</p>

            <button
              onClick={() => setIsCartOpen(false)}
            >
              CONTINUE SHOPPING
            </button>
          </div>
        ) : (
          <>
            <div className="cart-items">
              {cartItems.map((item) => (
                <div className="cart-item" key={item.key}>
                  <img
                    src={item.image}
                    alt={item.title}
                  />

                  <div className="cart-item-info">
                    <h3>{item.title}</h3>

                    {item.optionsLabel && (
                      <p>{item.optionsLabel}</p>
                    )}

                    <strong>
                      ₹{item.unitPrice.toLocaleString("en-IN")}
                    </strong>

                    <div className="cart-quantity">
                      <button
                        onClick={() =>
                          updateQuantity(
                            item.key,
                            item.quantity - 1
                          )
                        }
                        disabled={item.quantity <= 1}
                      >
                        <FiMinus />
                      </button>

                      <span>{item.quantity}</span>

                      <button
                        onClick={() =>
                          updateQuantity(
                            item.key,
                            item.quantity + 1
                          )
                        }
                      >
                        <FiPlus />
                      </button>
                    </div>
                  </div>

                  <button
                    className="cart-remove"
                    onClick={() => removeFromCart(item.key)}
                    aria-label="Remove product"
                  >
                    <FiTrash2 />
                  </button>
                </div>
              ))}
            </div>

            <div className="cart-footer">
              <div className="cart-subtotal">
                <span>Subtotal</span>

                <strong>
                  ₹{cartTotal.toLocaleString("en-IN")}
                </strong>
              </div>

              <p>Shipping and discounts calculated at checkout.</p>

              <button
                className="cart-checkout-btn"
                onClick={handleCheckout}
              >
                PROCEED TO CHECKOUT
              </button>

              <button
                className="cart-continue-btn"
                onClick={() => setIsCartOpen(false)}
              >
                CONTINUE SHOPPING
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CartDrawer;
